/* ---------------------------------------------------------------------------
   pm-mystery-gift.js — 2026-09-09

   Ajoute automatiquement le « Free Mystery Gift » (0 $) dès que le panier
   contient au moins un article payant, et le retire dès qu'il n'en contient
   plus.

   Décidé avec Imran : si le client supprime le cadeau, il revient. La
   réconciliation tourne donc à chaque rechargement de panier, sans mémoriser
   de suppression.

   Le garde-fou qui n'est PAS négociable : un panier composé uniquement du
   cadeau serait une commande à 0 $ (le cadeau demande quand même une
   expédition). Dès que le dernier article payant part, le cadeau part avec.

   Pourquoi ce produit ne perturbe pas la remise B2G1 : la remise automatique
   « B2G1 » est limitée aux collections Roll with the Best!, KIDS EMBOSSED
   ROLLING PIN et CUBES. Le cadeau n'appartient à aucune collection, il n'entre
   donc ni dans le « buy 2 » ni dans le « get 1 ». Si un jour on le range dans
   une collection, cette hypothèse tombe et il offrirait un article payant.

   Ciblage des lignes : par `key` et non par index. La remise BXGY scinde une
   même variante en plusieurs lignes (cf. pm-cart-merge.js), les index bougent.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  // Identifiants fournis par layout/theme.liquid depuis le reglage de theme
  // « Mystery Gift ». Rien n'est ecrit en dur ici : changer le produit se fait
  // dans le theme editor, et cart.ajax.liquid lit le meme reglage pour masquer
  // le selecteur de quantite. Reglage vide = pas d'identifiants = script inerte.
  var GIFT_VARIANT_ID = window.PM_GIFT_VARIANT_ID;
  var GIFT_PRODUCT_ID = window.PM_GIFT_PRODUCT_ID;
  if (!GIFT_VARIANT_ID || !GIFT_PRODUCT_ID) return;

  var busy = false;
  var failures = 0;
  var MAX_FAILURES = 3; // au-delà, on cesse : inutile de marteler une 422

  function giftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_id === GIFT_PRODUCT_ID) return cart.items[i];
    }
    return null;
  }

  function paidUnits(cart) {
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_id !== GIFT_PRODUCT_ID) n += cart.items[i].quantity;
    }
    return n;
  }

  function post(url, body) {
    busy = true;
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        busy = false;
        if (!r.ok) { failures++; return; }
        failures = 0;
        // Repeindre le drawer, sinon la ligne ajoutée n'apparaît qu'à la
        // prochaine ouverture — le panier serveur serait juste, l'affichage faux.
        //
        // C'est `update()` et non `load()` : load() est gardé par un `isLoaded`
        // et ne repeint que si le drawer porte encore sa classe de chargement,
        // donc il ne fait rien ici (vérifié en conditions réelles).
        // update() rejoue getCart + le rendu, et rediffuse afterCartLoad — d'où
        // un second passage dans reconcile(), sans effet puisque le panier est
        // alors conforme.
        if (window.theme && theme.ajaxCart) {
          if (typeof theme.ajaxCart.update === 'function') theme.ajaxCart.update();
          else if (typeof theme.ajaxCart.load === 'function') theme.ajaxCart.load();
        }
      })
      .catch(function () { busy = false; failures++; });
  }

  function reconcile(cart) {
    if (busy || failures >= MAX_FAILURES) return;
    if (!cart || !cart.items) return;

    var gift = giftLine(cart);
    var paid = paidUnits(cart);

    if (paid === 0) {
      // Panier vide de tout article payant : le cadeau ne reste pas seul.
      if (gift) post('/cart/change.js', { id: gift.key, quantity: 0 });
      return;
    }
    if (!gift) {
      post('/cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] });
      return;
    }
    if (gift.quantity !== 1) {
      post('/cart/change.js', { id: gift.key, quantity: 1 });
    }
    // Sinon le panier est déjà conforme : on ne touche à rien, ce qui arrête
    // la boucle déclenchée par notre propre theme.ajaxCart.update().
  }

  function fromNetwork() {
    if (busy || failures >= MAX_FAILURES) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(reconcile)
      .catch(function () {});
  }

  // Le thème diffuse le panier après chaque mise à jour ajax.
  if (window.jQuery) {
    jQuery('body').on('ajaxCart.afterCartLoad', function (e, cart) {
      if (cart && cart.items) reconcile(cart); else fromNetwork();
    });
  }
  document.addEventListener('dbtfy:cartLoaded', fromNetwork);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fromNetwork);
  } else {
    fromNetwork();
  }
})();
